import React, { useState, useEffect } from "react";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import feedback from "../assets/image/feedback.webp";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Feedback() {
  const [formData, setFormData] = useState({
    type: "",
    email: "",
    message: "",
    anonymous: false,
    can_be_contacted: false,
  });

  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      try {
        const user = JSON.parse(savedUser);
        if (user.email) {
          setFormData((prev) => ({ ...prev, email: user.email }));
          return;
        }
      } catch (e) {
        console.warn("Invalid user data in localStorage");
      }
    }

    fetch(`${TEST_BASE_URL}/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const email =
          data?.data?.email || data?.user?.email || data?.email || "";
        if (email)
          setFormData((prev) => ({
            ...prev,
            email,
          }));
      })
      .catch((err) => console.error("Error fetching user profile:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const missingFields = [];
    if (!formData.type) missingFields.push("type");
    if (!formData.email) missingFields.push("email");
    if (!formData.message) missingFields.push("message");

    if (missingFields.length > 0) {
      let message = "";
      if (missingFields.includes("type") && missingFields.includes("message")) {
        message = "Please select feedback type and enter a message.";
      } else if (missingFields.includes("type")) {
        message = "Please select feedback type.";
      } else if (missingFields.includes("email")) {
        message = "Please enter your email address.";
      } else if (missingFields.includes("message")) {
        message = "Please enter a message.";
      }

      toast.error(message, { theme: "colored" });
      return;
    }

    const token = localStorage.getItem("authToken");
    if (!token) {
      toast.error("You must be logged in to send feedback.", {
        theme: "colored",
      });
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${TEST_BASE_URL}/feedbacks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      console.log("Feedback Response:", data);

      if (!res.ok) {
        if (data.errors) {
          Object.entries(data.errors).forEach(([field, messages]) => {
            messages.forEach((msg) => toast.error(msg, { theme: "colored" }));
          });
        } else {
          toast.error(data.message || "Failed to send feedback.", {
            theme: "colored",
          });
        }
        return;
      }

      toast.success("Feedback sent successfully!", { theme: "colored" });
      setFormData({
        type: "",
        email: formData.email,
        message: "",
        anonymous: false,
        can_be_contacted: false,
      });
    } catch (err) {
      console.error("Error:", err);
      toast.error("Network error — please try again.", { theme: "colored" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />
        <div className="bottom-content">
          <div className="prayer-title">
            <span>Send a Feedback</span>
          </div>
          <div className="burdens-card">
            <div className="row burdenrow">
              <div className="col-md-5 px-4">
                <h5 className="burdens-card-head">Send Us Your Feedback</h5>
                <p>
                  We would love to hear from you. Your feedback helps us serve
                  you better and continue building a spiritually enriching
                  church community.
                </p>
                <img
                  src={feedback}
                  alt="Feedback"
                  width="90%"
                  className="feedback-image"
                />
                <div className="feedback-note">
                  <h6 className="pt-5">Note:</h6>
                  <p>
                    All feedback will be treated with confidentiality. If you'd
                    like a response, kindly include your contact details.
                  </p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="donationcard">
                  <h5>Feedback Form</h5>
                  <form onSubmit={handleSubmit} className="donationform">
                    <label>Feedback Type</label>
                    <select
                      name="type"
                      className="form-control"
                      value={formData.type}
                      onChange={handleChange}
                    >
                      <option value="">Select the type of your feedback</option>
                      <option value="suggestion">Suggestion</option>
                      <option value="compliment">Compliment</option>
                      <option value="complaint">Complaint</option>
                      <option value="testimony">Testimony</option>
                      <option value="other">Other</option>
                    </select>

                    <label>Email Address</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                    />

                    <label className="pb-2">Your Feedback</label>
                    <textarea
                      name="message"
                      cols="30"
                      rows="9"
                      className="form-control"
                      placeholder="Input your feedback"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>

                    <div className="sharediv mb-3">
                      <input
                        type="checkbox"
                        name="anonymous"
                        checked={formData.anonymous}
                        onChange={handleChange}
                      />
                      <span>Send my Feedback Anonymously</span>
                    </div>

                    <p className="pt-2">
                      <small>
                        Please read our{" "}
                        <a
                          href="https://www.rccgbournemouth.org/privacy-notice"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="privacy-link"
                        >
                          <small>
                            <u>Privacy Notice</u>
                          </small>
                        </a>{" "}
                        to learn how we protect your personal data.
                      </small>
                    </p>

                    <div className="mb-4">
                      <button
                        type="submit"
                        className="donatebutton"
                        disabled={loading}
                      >
                        {loading ? "Sending..." : "Send Feedback"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Feedback;
